/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type ItemFieldKind = (typeof ItemFieldKind)[keyof typeof ItemFieldKind];

export const ItemFieldKind = {
  Field: 0,
  SubItemGroup: 1,
  SubItemCollection: 2,
} as const;
